import request from '@/utils/request'
const BASE_URL = '/StAllotDoc'

//系统
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
   
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  examine(id) {
    return request({
      url: BASE_URL + '/Examine',
      method: 'get',
      params: { id }
    })
  },
  cancelExamine(id){
    return request({
      url: BASE_URL + '/CancelExamine',
      method: 'get',
      params: { id }
    })
  },
  referenceCost(data) {
    return request({
      url: BASE_URL + '/ReferenceCost',
      method: 'post',
      data
    })
  },
}